import { useEffect, useState } from "react";
import { MBL_SIZE } from "@directv-digital/dds.ui.dtv-theme";

// Mount-gated matchMedia(MBL_SIZE) hook — false on SSR and the first client
// render so hydration always matches; updates only on 600px boundary crossings.
// Use only where a JS boolean is unavoidable; visual breakpoints belong in sx.
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }
    const mql = window.matchMedia(MBL_SIZE);
    const update = () => setIsMobile(mql.matches);
    update();
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", update);
      return () => mql.removeEventListener("change", update);
    }
    // Safari < 14 fallback
    mql.addListener(update);
    return () => mql.removeListener(update);
  }, []);

  return isMobile;
};
